// PDP "Kluczowe składniki": zdjęcie i etykieta w kole podążają za otwartym składnikiem akordeonu
function init() {
    document.querySelectorAll('[data-ingredients]').forEach((section) => {
        const image = section.querySelector('[data-ingredients-image]'),
            label = section.querySelector('[data-ingredients-label]');

        if (!image || !label) {
            return;
        }

        section.addEventListener('accordion:toggle', (event) => {
            const item = event.target;

            if (!event.detail.open || !item.dataset.ingredientName) {
                return;
            }

            label.textContent = item.dataset.ingredientName;

            if (item.dataset.ingredientImage && image.getAttribute('src') !== item.dataset.ingredientImage) {
                image.classList.add('is-changing');
                const next = new Image();
                next.onload = next.onerror = () => {
                    image.src = item.dataset.ingredientImage;
                    image.classList.remove('is-changing');
                };
                next.src = item.dataset.ingredientImage;
            }
        });
    });
}

export default {init};
